<div class="folder d-flex flex-column gap-2">
    <!-- Default content -->
    <ng-content></ng-content>
    <!-- Folder Content -->
    <ng-content select="folder-content"></ng-content>
    <!-- Caption content -->
    <div class="d-flex justify-content-between align-items-center flex-grow-1">
        <ng-content select="caption"></ng-content>
    </div>
</div>
